// extracted by mini-css-extract-plugin
export default {"pricingLoaderContainer":"Pricing_pricingLoaderContainer__GK+T-"};